import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import { Icon } from '@zen/DesignSystem';

import type { ListItemType } from '../VerticalList/ListItem';

interface ListItemProps {
  customContent?: ReactNode;
  isSelected: boolean;
  item: ListItemType;
  onClick?: () => void;
}

const AIListItem: FC<ListItemProps> = (props: ListItemProps) => {
  const { customContent, isSelected, item, onClick = () => false } = props;

  const outerClassNames: string = cx({ 'bg-sunset-base': isSelected, 'bg-grey-lighter': !isSelected }, 'p-0.5 rounded');

  const innerClassNames: string = cx(
    'text-base xl:text-sm transition-all duration-200 ease-linear leading-normal',
    'flex justify-between w-full bg-white h-12 items-center py-1.5 pl-2 cursor-pointer rounded-xs'
  );

  return (
    <div className={outerClassNames}>
      <div className={innerClassNames} data-testid="searchable-list-item" onClick={onClick}>
        <div className="flex items-center gap-2">
          <p>{item.label}</p>
          {customContent}
        </div>

        {isSelected && (
          <div className="mr-4">
            <Icon className={'text-transparent right-4 cursor-pointer bg-sunset-base bg-clip-text'} icon="zicon-tick" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AIListItem;
